import type { Messages } from "../types";

export const pt_BR = {
  "common": {
    "brand": "UN8",
    "brandTag": "Namoro cristão exclusivo",
    "continue": "Continuar",
    "leave": "Deixar",
    "leaveForNow": "Saia por enquanto",
    "yes": "Sim",
    "no": "Não",
    "goBack": "Volte",
    "saving": "Salvando…",
    "submitting": "Enviando…",
    "pleaseWait": "Por favor, aguarde…",
    "ellipsis": "…",
    "male": "Macho",
    "female": "Fêmea",
    "phases": {
      "gate": "Portão",
      "verify": "Verificar",
      "setup": "Configurar",
      "profile": "Perfil"
    },
    "storageQuota": "Este telefone não tem espaço para respostas salvas. Libere espaço de armazenamento e tente novamente.",
    "storageDisabled": "Este navegador não salvará suas respostas. Desative o modo privado ou permita os dados do site e recarregue.",
    "charMeta": "{len}/{min} min · {current}/{max}",
    "charMetaMin": "mínimo de caracteres {min}"
  },
  "welcome": {
    "promise": "Nosso objetivo é que você exclua este aplicativo o mais rápido possível.",
    "sub": "UN8 ajuda cristãos sérios solteiros a encontrar um parceiro para a vida - e depois ir embora. Verificado. Valores em primeiro lugar. Não há deslizamento interminável.",
    "signedInAs": "Conectado como {email}",
    "liveServer": "· servidor ativo",
    "deviceOnly": "· apenas este dispositivo",
    "migrateOffer": "Este dispositivo ainda possui um perfil local. Carregá-lo no servidor compartilhado para que outros telefones possam ver você após moderação? Nada é carregado até que você escolha.",
    "uploadLocalProfile": "Carregar meu perfil local",
    "keepOnDevice": "Mantenha-o apenas neste dispositivo",
    "migrateNeedGender": "Escolha primeiro Masculino ou Feminino em seu perfil.",
    "migrateDone": "Texto do perfil enviado. Reenvie ID, vídeo e fotos para que a moderação possa revisá-los.",
    "deleteConfirm": "Excluir permanentemente sua conta, todas as mensagens e todas as mídias (incluindo ID e vídeo) do servidor?",
    "accountDeleted": "Conta excluída.",
    "begin": "Começar",
    "continueOnboarding": "Continuar a integração",
    "logIn": "Conecte-se",
    "logOut": "Sair",
    "reviewConsole": "Revise o console",
    "matching": "Correspondência",
    "deleteMyAccount": "Excluir minha conta"
  },
  "faith": {
    "eyebrow": "Portão da fé",
    "title": "Somente cristãos",
    "text": "UN8 é uma comunidade de seguidores de Jesus Cristo, para membros que buscam um parceiro que pense no casamento e que compartilhe essa fé. Este portão não pode ser ignorado.",
    "yesTitle": "Eu sou cristão",
    "yesBody": "Sigo Jesus Cristo e procuro um parceiro que pense no casamento e que compartilhe essa fé.",
    "noTitle": "Eu não sou cristão",
    "noBody": "UN8 não é o lugar certo para mim – e está tudo bem.",
    "respectTitle": "Com respeito",
    "respectBody": "UN8 foi criado para uma comunidade e preferimos ser honestos a desperdiçar seu tempo. Use Sair abaixo ou Voltar, se esta não for sua casa.",
    "sharedTitle": "Fundação compartilhada",
    "sharedBody": "A fé não é um rótulo aqui. É o terreno onde vocês se encontram.",
    "hintNotChristian": "UN8 é para seguidores de Jesus Cristo. Toque em Sair abaixo ou escolha a opção cristã se for você.",
    "hintUnset": "Toque em “Sou cristão” para continuar ou em Sair/Voltar se esta não for sua casa."
  },
  "rules": {
    "eyebrow": "Pacto comunitário",
    "title": "Como tratamos uns aos outros",
    "text": "Afirme todas as regras. Todos os três são obrigatórios. As violações levam à remoção permanente. Perfis falsos são banidos para sempre.",
    "agreeContinue": "Eu concordo - continue",
    "respectful": {
      "title": "Seja respeitoso",
      "description": "Fale e aja com dignidade. Cada pessoa aqui é feita à imagem de Deus."
    },
    "noSexualContent": {
      "title": "Nenhum conteúdo sexual",
      "description": "Sem fotos, mensagens ou solicitações explícitas. A pureza não é opcional aqui."
    },
    "noDominance": {
      "title": "Não domine ou controle",
      "description": "Sem coerção, manipulação ou pressão. O amor não controla."
    },
    "hint": "Marque todas as três promessas antes de continuar."
  },
  "intent": {
    "eyebrow": "",
    "title": "O que você está procurando?",
    "text": "",
    "marriage": {
      "label": "Um par para a vida",
      "description": ""
    },
    "discernment": {
      "label": "Discernir com seriedade",
      "description": ""
    },
    "notCasual": {
      "label": "Nada casual",
      "description": ""
    },
    "hint": "Escolha uma."
  },
  "account": {
    "eyebrow": "Conta",
    "title": "Crie seu acesso",
    "text": "Seu identificador cria um ID de usuário estável. Aplicação, verificação, curtidas e correspondências estão vinculadas a esse ID. Nenhum e-mail é enviado.",
    "recoveryTitle": "Salve seu código de recuperação",
    "recoveryText": "Mostrado uma vez. Sem ele, uma senha perdida não pode ser redefinida neste teste fechado.",
    "savedContinue": "Eu salvei – continue",
    "handle": "Lidar",
    "handlePlaceholder": "you@example.com ou um identificador curto",
    "passphrase": "Senha",
    "passphrasePlaceholder": "Pelo menos 8 caracteres",
    "signedInTitle": "Conectado",
    "signedInBody": "{email} · {userId}",
    "trustTitle": "Padrão de confiança",
    "trustBody": "Nenhum perfil fica visível até que a verificação de identidade seja concluída e a moderação aprove você.",
    "continueToVerification": "Continuar para verificação",
    "hintEmail": "Digite um endereço de e-mail que inclua @.",
    "hintPassword": "Escolha uma senha de pelo menos 8 caracteres."
  },
  "verify": {
    "intro": {
      "eyebrow": "Verificação",
      "title": "A confiança é a porta",
      "text": "Carregue uma identificação governamental, um vídeo de confirmação e fotos reais {min}–{max}. Tudo entra em uma fila de revisão antes que seu perfil apareça.",
      "whyTitle": "Por que verificamos",
      "whyBody": "A pesca do gato e as meias verdades não têm lugar aqui. Perfis falsos são banidos permanentemente. A mídia é armazenada com status pending_review até ser aprovada.",
      "start": "Iniciar verificação"
    },
    "steps": {
      "id": {
        "title": "ID do governo",
        "description": "Passaporte ou identidade nacional – câmera ou upload de arquivo."
      },
      "video": {
        "title": "Vídeo de confirmação",
        "description": "Uma pequena gravação que prova que você está presente."
      },
      "photos": {
        "title": "Fotos reais",
        "description": "Sete a dez fotos nítidas de você mesmo."
      },
      "review": {
        "title": "Revisão de integridade",
        "description": "Os uploads permanecem pending_review até que a equipe confirme."
      }
    },
    "id": {
      "eyebrow": "Etapa 1 de 4",
      "title": "ID do governo",
      "text": "Capture ou carregue seu passaporte ou identidade nacional. Nada é postado publicamente – o status permanece pending_review até que a equipe confirme.",
      "savedTitle": "ID salvo",
      "savedBody": "A seguir vem um pequeno vídeo de confirmação do seu rosto e, em seguida, 7 a 10 fotos reais suas. Continue desbloqueando quando este ID aparecer salvo.",
      "hint": "Tire ou carregue uma foto do seu documento de identidade governamental e espere até que apareça salvo."
    },
    "video": {
      "eyebrow": "Etapa 2 de 4",
      "title": "Vídeo de confirmação",
      "text": "Grave um clipe curto ou carregue um. Fique de frente para a câmera. Fale claramente. Isso prova que você está presente – e não uma galeria destruída.",
      "hint": "Grave um breve vídeo de confirmação e espere até que apareça salvo."
    },
    "photos": {
      "eyebrow": "Etapa 3 de 4",
      "title": "Fotos reais",
      "text": "Adicione {min} – 10 fotos recentes suas. Use a câmera ou sua biblioteca. Toque em × para remover qualquer foto.",
      "continueToReview": "Continuar a revisar",
      "hint": "Adicione {min} a 10 fotos nítidas suas. Continue desbloqueando quando eles forem salvos."
    },
    "review": {
      "eyebrow": "Etapa 4 de 4",
      "title": "Revisão de integridade",
      "text": "A mídia está na fila como pending_review{underUser}. Correspondências e curtidas usarão o mesmo ID.",
      "underUser": "sob o usuário {userId}",
      "governmentId": "ID do governo",
      "confirmationVideo": "Vídeo de confirmação",
      "photos": "Fotos",
      "missing": "Ausente",
      "filesReady": "Arquivos {count} prontos",
      "submittedTitle": "Enviado para revisão",
      "submittedText": "O ID do aplicativo é igual ao ID do usuário de autenticação, então aprove → pool e curtidas mútuas permanecem alinhados.",
      "submitContinue": "Enviar e continuar"
    }
  },
  "setup": {
    "eyebrow": "Configuração da conta",
    "title": "Diga a verdade sobre você",
    "text": "Essas respostas moldam a correspondência e aparecem na revisão. Mentiras suaves desperdiçam o tempo de todos - inclusive o seu.",
    "beginSetup": "Iniciar a configuração",
    "pillars": {
      "faith": {
        "name": "Fé",
        "text": "Por que você segue a Cristo."
      },
      "character": {
        "name": "Personagem",
        "text": "Lealdade, honestidade, paixão, comprometimento — avaliado de 1 a 10."
      },
      "story": {
        "name": "História",
        "text": "Quem você é e o que você busca."
      },
      "life": {
        "name": "Vida",
        "text": "Hobbies, leitura e vocação."
      }
    },
    "whyChristian": {
      "eyebrow": "Fé",
      "title": "Por que você é cristão?",
      "text": "Uma resposta curta e honesta. Não é um sermão – uma razão que é sua.",
      "label": "Sua Resposta",
      "placeholder": "por exemplo Conheci Cristo em um período de perda e O tenho seguido desde…",
      "hint": "Escreva pelo menos caracteres {min} sobre por que você segue Jesus."
    }
  },
  "scales": {
    "eyebrow": "Escalas de caracteres",
    "title": "Avalie-se honestamente",
    "text": "Lealdade, honestidade, paixão, comprometimento – cada um de 1 a 10. Inflar os números só faz com que você não combine mais tarde. Você deve definir todas as escalas para continuar.",
    "loyalty": {
      "label": "Nível de lealdade",
      "hint": "Seja honesto – quão fielmente você é ao lado daqueles que ama?"
    },
    "honesty": {
      "label": "Nível de honestidade",
      "hint": "Com que consistência você diz toda a verdade?"
    },
    "passion": {
      "label": "Quão apaixonado você é?",
      "hint": "Convicção e profundidade – não desempenho."
    },
    "commitment": {
      "label": "Nível de compromisso",
      "hint": "Você está pronto para construir algo que dure?"
    },
    "hint": "Mova cada controle deslizante para que um número seja exibido – nenhum pode permanecer como um travessão."
  },
  "about": {
    "eyebrow": "Sobre você",
    "title": "Descreva-se em algumas frases",
    "text": "Quem você é quando ninguém está atuando. Temperamento, ritmo, o que importa no dia a dia.",
    "label": "Sobre você",
    "placeholder": "Manhãs tranquilas, sério em relação à família, ri com facilidade, prefere a profundidade ao barulho…",
    "hint": "Escreva pelo menos caracteres {min} sobre você."
  },
  "looking": {
    "eyebrow": "Parceiro",
    "title": "O que você está procurando?",
    "text": "Principais traços de caráter que você deseja em um parceiro em potencial - não uma lista de compras de looks.",
    "label": "Traços de caráter desejados",
    "placeholder": "por exemplo Fé inabalável, maturidade emocional, bondade sob estresse…",
    "hint": "Escreva pelo menos caracteres {min} sobre o parceiro que você espera."
  },
  "loveReady": {
    "eyebrow": "Limite",
    "title": "Você está pronto para conhecer o amor da sua vida?",
    "text": "UN8 existe para que solteiros sérios encontrem um parceiro - e então excluam o aplicativo. Apenas os desbloqueios “Sim” continuam.",
    "yesTitle": "Sim - estou pronto",
    "yesBody": "Estou aqui para conhecer minha pessoa com clareza e coragem.",
    "noTitle": "Ainda não",
    "noBody": "Se você está apenas navegando, esta comunidade não é a opção certa.",
    "comeBackTitle": "Volte quando estiver pronto",
    "comeBackBody": "UN8 é para pessoas preparadas para se encontrarem – não para colecionar opções. Use Sair abaixo se quiser parar por enquanto. Suas respostas estão salvas neste telefone.",
    "hintNo": "Apenas “Sim” continua. Se você não estiver pronto, toque em Sair por enquanto – suas respostas permanecerão neste telefone.",
    "hintUnset": "Toque em Sim se estiver pronto para encontrar alguém para casamento."
  },
  "lifestyle": {
    "eyebrow": "Estilo de vida",
    "title": "Como você vive o dia a dia",
    "text": "Esportes, hobbies, leitura e profissão – sinais práticos para uma compatibilidade real.",
    "hobbies": "Esportes ou hobbies atuais",
    "hobbiesPlaceholder": "O que você faz ativamente – não o que você costumava fazer antes.",
    "reading": "Você lê?",
    "readingHint": "1 = quase nunca · 10 = diariamente, leitura profunda",
    "profession": "Profissão/setor",
    "professionPlaceholder": "por exemplo Enfermagem · Software · Educação · Ofícios",
    "hintHobbies": "Cite pelo menos um esporte ou hobby que você realmente pratica.",
    "hintReading": "Deslize “Você lê?” então um número de 1 a 10 mostra.",
    "hintProfession": "Digite o trabalho que você faz, mesmo que seja uma palavra curta."
  },
  "faithDepth": {
    "eyebrow": "Correspondência · Fé",
    "title": "Quão central é a sua fé?",
    "text": "Servir a Deus – quão importante é na sua vida? Responda honestamente. A correspondência usa isso para profundidade, não para desempenho.",
    "serving": "Servir a Deus – importância",
    "servingHint": "10%… 100%. Deslize em etapas de 10.",
    "keepsCommandments": "Você guarda os mandamentos?",
    "grewUpInChurch": "Você cresceu na igreja?",
    "churchAttendance": "Frequência à igreja",
    "frequent": {
      "label": "Freqüente",
      "hint": "Reunião regular com o corpo de Cristo."
    },
    "seldom": {
      "label": "Raramente",
      "hint": "Ocasionalmente, não é um ritmo semanal."
    },
    "never": {
      "label": "Nunca",
      "hint": "Atualmente não frequento."
    },
    "spreadsGospel": "Você espalha o evangelho?",
    "hasIdols": "Você tem ídolos?",
    "hintServing": "Deslize o quão importante é servir a Deus em sua vida.",
    "hintCommandments": "Responda se você guarda os mandamentos – Sim ou Não.",
    "hintGrewUp": "Responda se você cresceu na igreja – Sim ou Não.",
    "hintAttendance": "Escolha com que frequência você frequenta a igreja.",
    "hintGospel": "Responda se você compartilha o evangelho – Sim ou Não.",
    "hintIdols": "Responda se você tem ídolos – Sim ou Não."
  },
  "character": {
    "eyebrow": "Correspondência · Personagem",
    "title": "Quem você é em casa",
    "text": "Caráter para namoro – pacificação, boas maneiras, honestidade. Inflar as respostas só faz com que você não corresponda mais tarde.",
    "peacemaker": "Você é um pacificador?",
    "homebuilder": "Você é construtor de casas?",
    "humorous": "Você é bem-humorado?",
    "caring": "Carinhoso e carinhoso?",
    "peacefulHome": "Você quer um lar pacífico – livre de brigas?",
    "manners": "Boas maneiras?",
    "honestyRating": "Avaliação de honestidade neste questionário",
    "honestyHint": "1–10 – com que honestidade você está respondendo?",
    "hintPeacemaker": "Responda sim ou não, começando com pacificador.",
    "hintHomebuilder": "Responda se você é construtor de casas.",
    "hintHumorous": "Responda se você é bem-humorado.",
    "hintCaring": "Responda se você é atencioso e afetuoso.",
    "hintPeaceful": "Responda se você quer um lar tranquilo.",
    "hintManners": "Responda se você tem boas maneiras.",
    "hintHonesty": "Deslize sua classificação de honestidade de 1 para 10."
  },
  "history": {
    "eyebrow": "Correspondência · História",
    "title": "Passado e prontidão",
    "text": "Substâncias, infância, cicatrizes e se você está pronto para um relacionamento duradouro. A verdade aqui protege vocês dois.",
    "marijuana": "Você já usou maconha?",
    "lsd": "Você já usou LSD?",
    "otherDrugs": "Você já usou outras drogas?",
    "addicted": "Você já foi viciado?",
    "childhood": "Infância estável e amorosa?",
    "scars": "Alguma cicatriz/danificada?",
    "lasting": "Pronto para um relacionamento duradouro?",
    "hintStart": "Responda a cada Sim ou Não nesta página, começando no topo.",
    "hintLsd": "Responda à pergunta do LSD – Sim ou Não.",
    "hintOtherDrugs": "Responda se você já usou outras drogas.",
    "hintAddicted": "Responda se você foi viciado.",
    "hintChildhood": "Responda se sua infância foi estável e amorosa.",
    "hintScars": "Responda se você carrega cicatrizes.",
    "hintLasting": "Responda se você está pronto para um relacionamento duradouro."
  },
  "appearance": {
    "eyebrow": "Correspondência · Aparência",
    "title": "Tatuagens",
    "text": "Suas tatuagens e se as tatuagens de um parceiro são aceitáveis ​​para você.",
    "hasTattoos": "Você tem tatuagens?",
    "acceptsPartner": "Aceitar tatuagens em um parceiro?",
    "hintHas": "Diga se você tem tatuagens – sim ou não.",
    "hintAccepts": "Diga se as tatuagens em um parceiro são aceitáveis ​​para você."
  },
  "home": {
    "eyebrow": "Correspondente · Casa e terreno",
    "title": "Terra, habilidades, autossuficiência",
    "text": "Ervas, cultivo de alimentos, florestas frutíferas, preparação, agricultura comunitária, preservação, sobrevivência — e quaisquer habilidades especiais.",
    "herbKnowledge": "Conhecimento de ervas?",
    "plantOwn": "Você planta suas próprias frutas e vegetais?",
    "fruitForest": "Interessado em uma floresta frutífera?",
    "prepping": "Preparando-se para calamidades?",
    "communityFarming": "Agricultura comunitária/vida independente?",
    "canning": "Enlatar e conservar?",
    "survival": "Habilidades de sobrevivência?",
    "specialSkills": "Habilidades especiais (opcional)",
    "specialPlaceholder": "Qualquer outra coisa que você traga para uma casa ou terreno…",
    "hintStart": "Responda a cada Sim ou Não em terrenos e habilidades, começando pelo topo.",
    "hintPlant": "Responda se você planta suas próprias frutas e vegetais.",
    "hintFruitForest": "Responda se uma floresta frutífera lhe interessa.",
    "hintPrepping": "Responda se você está se preparando para calamidades.",
    "hintCommunity": "Responda se a agricultura comunitária lhe interessa.",
    "hintCanning": "Responda se puder e conserve os alimentos.",
    "hintSurvival": "Responda se você tem habilidades de sobrevivência."
  },
  "family": {
    "eyebrow": "Correspondente · Família",
    "title": "Crianças, profundidade de fé, substâncias",
    "text": "O que você precisa em um parceiro sobre intensidade de fé, filhos e uso anterior de substâncias.",
    "children": "Crianças",
    "wants": {
      "label": "Quer filhos",
      "hint": "Construir uma família faz parte da visão."
    },
    "doesNotWant": {
      "label": "Não quer filhos",
      "hint": "Deixe claro não para as crianças."
    },
    "open": {
      "label": "Abrir",
      "hint": "Discernimento – não bloqueado de qualquer maneira."
    },
    "hasLivingWith": {
      "label": "Tem filhos – mora com eles",
      "hint": "As crianças já fazem parte do dia a dia."
    },
    "requiredFaith": "Nível mínimo de fé que você precisa em um parceiro",
    "requiredFaithHint": "10%… 100%. Portão rígido quando ambos os lados responderam.",
    "acceptsSubstances": "Aceita o uso anterior de substâncias por um parceiro?",
    "hintChildren": "Escolha um cartão sobre crianças.",
    "hintFaith": "Defina o nível mínimo de fé que você espera de um parceiro.",
    "hintSubstances": "Diga se o uso anterior de substâncias por um parceiro é aceitável."
  },
  "ancestry": {
    "eyebrow": "Correspondência · Plano de fundo",
    "title": "Preferências de plano de fundo",
    "text": "Compartilhe sua experiência e o que você está aberto a um parceiro. Isso apenas molda a classificação – nunca esconde alguém do baralho.",
    "yourBackground": "Seu histórico (selecione todas as opções aplicáveis)",
    "openToPartner": "Aberto a um parceiro",
    "codeDesc": "Código: {code}",
    "anyDesc": "Preferência mais forte por amplitude – recomendada quando não tiver certeza.",
    "preferenceOnly": "Apenas preferência – não um portão.",
    "hintOwn": "Marque pelo menos um histórico que descreva você. Isso só ajuda na classificação – nunca esconde ninguém.",
    "hintAccepted": "Marque o que você está aberto em um parceiro ou “Aberto – sem preferência”."
  },
  "interests": {
    "eyebrow": "Correspondência · Interesses",
    "title": "O que você gosta",
    "text": "Escolha pelo menos um. A sobreposição ajuda na classificação; o silêncio nunca é punido.",
    "hint": "Marque pelo menos um interesse."
  },
  "reflection": {
    "eyebrow": "Correspondência · Reflexão",
    "title": "Em suas próprias palavras",
    "text": "Estas quatro respostas são mostradas na íntegra e nunca pontuadas. Escreva o que é verdade.",
    "describeYourself": "Descreva-se",
    "lifePurpose": "Propósito de vida",
    "fifteenYear": "Você e o amor da sua vida daqui a 15 anos",
    "weaknesses": "Fraquezas",
    "hintDescribe": "Descreva-se com pelo menos caracteres {min}.",
    "hintPurpose": "Escreva o propósito de sua vida em pelo menos caracteres {min}.",
    "hintVision": "Escreva a visão de 15 anos em pelo menos caracteres {min}.",
    "hintWeaknesses": "Cite um ponto fraco em pelo menos caracteres {min}."
  },
  "profile": {
    "eyebrow": "Perfil",
    "title": "Alguns itens essenciais",
    "text": "Mantenha a simplicidade. O sexo é binário aqui – masculino ou feminino – para uma correspondência clara.",
    "firstName": "Primeiro nome",
    "firstNamePlaceholder": "Como você deseja ser conhecido",
    "age": "Idade",
    "agePlaceholder": "18+",
    "city": "Cidade",
    "cityPlaceholder": "Onde você está baseado",
    "sex": "Sexo",
    "maleBody": "Eu sou um homem.",
    "femaleBody": "Eu sou uma mulher.",
    "hintName": "Digite seu primeiro nome (pelo menos duas letras).",
    "hintAge": "A idade deve ser 18 anos ou mais.",
    "hintCity": "Digite a cidade onde você mora.",
    "hintGender": "Escolha Masculino ou Feminino para que a correspondência funcione."
  },
  "ready": {
    "title": "Você pode entrar.",
    "textNamed": "{name}, sua verificação e configuração serão registradas. A mídia é pending_review. Bem-vindo ao UN8 – encontre sua pessoa e exclua o aplicativo.",
    "text": "Sua verificação e configuração são registradas. A mídia é pending_review. Bem-vindo ao UN8 – encontre sua pessoa e exclua o aplicativo.",
    "summaryAria": "Resumo de configuração",
    "christianRules": "Cristão · regras afirmadas",
    "mediaLine": "ID · vídeo · fotos {photoCount} · fila {pending}",
    "scalesLine": "Balanças L{loyalty}/H{honesty}/P{passion}/C{commitment}",
    "genderProfession": "{gender} · {profession}",
    "sexUnset": "Sexo -",
    "professionFallback": "profissão",
    "userLine": "Usuário {userId}",
    "enterMatching": "Insira a correspondência",
    "needGender": "Volte para a etapa do perfil e escolha Masculino ou Feminino e tente novamente."
  },
  "match": {
    "brandTag": "Correspondência",
    "navOnboarding": "Integração",
    "navReview": "Análise",
    "navMatching": "Correspondência",
    "logOut": "Sair",
    "quietSignIn": "Entrar",
    "enterTitle": "Insira a correspondência",
    "enterText": "Faça login com o mesmo e-mail da integração. Aplicativo, pool, curtidas e correspondências usam seu ID de usuário estável.",
    "email": "E-mail",
    "emailPlaceholder": "você@exemplo.com",
    "password": "Senha",
    "passwordPlaceholder": "Sua senha",
    "logIn": "Conecte-se",
    "guestOr": "Ou tente uma sessão de convidado (ID estável por navegador · apenas demonstração)",
    "guestMan": "Convidado como homem",
    "guestWoman": "Convidada como mulher",
    "goOnboarding": "Vá para integração →",
    "guestSession": "Sessão de convidado · pool de demonstração",
    "man": "homem",
    "woman": "mulher",
    "tabToday": "Seleção",
    "tabMatches": "Correspondências ({count})",
    "yourMatches": "Suas partidas",
    "matchesSub": "Interesse mútuo persistente · {count} saída {likesWord}",
    "like": "como",
    "likes": "gosta",
    "emptyMatches": "Ainda não há interesse mútuo. Continue discernindo a seleção desta semana.",
    "valuesScore": "Valores {score}",
    "chatOpen": "· Bate-papo aberto",
    "tapToChat": "· Toque para conversar",
    "personLine": "{name}, {age}",
    "cityValues": "{city} · Valores {score}",
    "noProfileYet": "Ainda sem perfil",
    "noProfileText": "Conclua a integração ou toque em Integração na parte superior e depois em Iniciar. A correspondência de convidados está na tela de entrada se você quiser apenas olhar.",
    "matchingPaused": "Correspondência pausada",
    "noOneYet": "Ninguém para mostrar ainda",
    "todaysSetDone": "Essa é a seleção desta semana",
    "emptyNeverHad": "Não há ninguém na seleção desta semana. Se você acabou de fazer a integração, o pool ao vivo ainda pode estar vazio. Experimente uma sessão de convidado para ver o pessoal da demonstração ou volte depois que mais membros forem aprovados.",
    "emptyDone": "Você percorreu a seleção desta semana. Volte na próxima semana ou reinicie o baralho para olhar novamente.",
    "likesMayNotStick": "Curtidas podem não durar.",
    "poolMeta": "Grupo: {pool} · Partidas: {matches} · Gostou: {liked}",
    "demoPool": "demonstração",
    "livePool": "{source} ({count})",
    "resetDeck": "Redefinir baralho",
    "backOnboarding": "Voltar à integração",
    "feedEyebrowDemo": "Seleção semanal · Demo pool",
    "feedEyebrowLive": "Seleção semanal · Pool ({source}, {count})",
    "feedTitle": "Discernir com cuidado",
    "left": "{count} restantes",
    "pass": "Passar",
    "interested": "Interessado",
    "likeHeart": "♥ Curtir",
    "flame": "🔥 Chama",
    "flameNoneLeft": "Não restou chama esta semana. Volta na segunda-feira.",
    "flameLead": "Você gosta mesmo de {name}. Escreva algo — ou pule.",
    "flameOnly": "Só chama",
    "flameSend": "Enviar chama com isto",
    "flameBurstTitle": "Uma chama para {name}",
    "flameSent": "Você enviou uma chama para {name}.",
    "heartsNoneLeft": "Não restam corações esta semana. Eles voltam na segunda-feira.",
    "commentLead": "Diga uma coisa para {name}. Dez palavras.",
    "commentPlaceholder": "Dez palavras, no máximo",
    "commentCount": "{count} / {max}",
    "commentSend": "Enviar coração com isso",
    "heartOnly": "Só coração",
    "commentTooLong": "São mais de {max} palavras. O coração foi; a nota não.",
    "commentAnchors": {
      "about": "Sobre mim",
      "lookingFor": "Procuro",
      "hobbies": "Interesses",
      "photo": "Foto"
    },
    "inboundTitle": "Curtiu você",
    "likeBack": "Curtir de volta",
    "swipeHint": "Deslize ou use os botões. Uma partida só se abre quando o interesse é mútuo e persistente.",
    "celebrationEyebrow": "Interesse mútuo",
    "celebrationTitle": "Você combinou",
    "celebrationText": "{self} e {other} mostraram interesse. Alinhamento de valores: {score}.",
    "celebrationNote": "O bate-papo está desbloqueado para esta partida. Mantenha o respeito – convênio em vez de conveniência.",
    "openChat": "Abrir bate-papo",
    "keepDiscerning": "Continue discernindo",
    "cardSeeking": "Buscando",
    "cardHobbies": "Passatempos",
    "affinity": "Afinidade",
    "valuesScoreLabel": "Pontuação de valores",
    "scoreStrong": "Alinhamento forte",
    "scoreSolid": "Alinhamento sólido",
    "scoreModerate": "Alinhamento moderado",
    "scoreDifferent": "Ritmos diferentes",
    "characterAxisFoot": "O eixo do personagem inclui os quatro pilares",
    "youThem": "Você {self} · Eles {other}",
    "stampInterest": "Interesse",
    "stampPass": "Passar",
    "explainLegacyClose": "Suas pontuações de valores ficam próximas ({score} de 100).",
    "explainLegacyFuller": "Um “porquê” mais completo aparece depois que vocês dois terminam as perguntas correspondentes.",
    "explainFaith": "A intensidade da sua fé está próxima – você segue Jesus com seriedade semelhante.",
    "explainCharacter": "A maneira como você trata as pessoas em casa se alinha - paz, boas maneiras e cuidado.",
    "explainPurpose": "Você avaliou sua própria honestidade de forma semelhante, o que é um sinal de seriedade compartilhada.",
    "explainHome": "Você compartilha o interesse por terra, cultivo de alimentos ou uma casa autossuficiente.",
    "explainAncestry": "Vocês dois preferem origens familiares semelhantes. Isso é uma preferência, não um filtro – ninguém está escondido disso.",
    "explainTemperament": "Seus interesses e temperamento se sobrepõem.",
    "explainFallback": "Há uma possível correspondência nas respostas que vocês dois preencheram.",
    "explainOverall": "Afinidade geral {score} de 100.",
    "affinityAxes": {
      "faith": "Intensidade da fé",
      "character": "Caráter e conduta",
      "purpose": "Alinhamento do propósito de vida",
      "home": "Casa e autossuficiência",
      "ancestry": "Afinidade cultural e de origem",
      "temperament": "Ajuste de temperamento"
    },
    "scaleAxes": {
      "loyalty": "Lealdade",
      "honesty": "Honestidade",
      "passion": "Paixão",
      "commitment": "Compromisso"
    },
    "weeklyTitle": "Seus 4 desta semana",
    "weeklyTitleCount": "Seus {count} desta semana",
    "weeklyCountdown": "Próxima seleção em {days} dias",
    "weeklyCountdownOne": "Próxima seleção em 1 dia",
    "weeklyCountdownSoon": "Próxima seleção em breve",
    "shortWeekCopy": "Esta semana há {count}. Nunca sugerimos alguém que não se encaixe.",
    "shortWeekTwo": "Esta semana há dois. Nunca sugerimos alguém que não se encaixe.",
    "weekDone": "Essa é a seleção desta semana",
    "weekDoneText": "Você discerniu todos que pudemos sugerir com honestidade. Volte quando a próxima seleção abrir.",
    "waitingModeration": "Seu perfil aguarda aprovação da moderação antes de a seleção abrir.",
    "completeProfileFirst": "Complete seu perfil e envie primeiro.",
    "moderationDemoNote": "Mostramos pessoas de demonstração para você experimentar a correspondência.",
    "navSelection": "Seleção",
    "navMessages": "Mensagens",
    "navProfile": "Perfil",
    "packTitle": "Seus quatro",
    "packSkip": "Toque para continuar",
    "refreshTitle": "Nova seleção",
    "newSelection": "Nova seleção",
    "backToFour": "← Voltar aos seus quatro",
    "whoLikedTitle": "Quem curtiu você",
    "whoLikedEmpty": "Ninguém novo curtiu você ainda.",
    "whoLikedLocked": "Assine para ver nomes na seleção semanal — os corações recebidos continuam em Mensagens.",
    "verify": {
      "brandTag": "Verificar",
      "title": "Verifique-se para conversar",
      "sub": "Qualquer um pode olhar e curtir. Uma conversa precisa do seu documento e de um vídeo curto de confirmação. Enviar já basta — a análise pode esperar.",
      "cta": "Adicionar documento e vídeo",
      "videoCta": "Adicionar vídeo de confirmação",
      "submitted": "Documento e vídeo recebidos. Você pode conversar enquanto analisamos.",
      "done": "Você está verificado.",
      "back": "Voltar",
      "continue": "Continuar",
      "idEyebrow": "Identidade",
      "videoEyebrow": "Presença",
      "idText": "Passaporte ou RG. Nada é publicado. Enviar já basta para poder conversar.",
      "videoText": "Um clipe curto (cerca de {seconds} segundos). Olhe para a câmera. Isso prova que você está presente."
    }
  },
  "chat": {
    "brandTag": "Bater papo",
    "unavailableTitle": "Bate-papo indisponível",
    "unavailableText": "Esta correspondência está faltando ou não pertence à sua sessão.",
    "backToMatches": "Voltar às correspondências",
    "backMatches": "← Correspondências",
    "valuesSubscriber": "Valores {score} · Assinante",
    "valuesTrial": "Valores {score} · Teste",
    "valuesKept": "Valores {score} · Correspondência mantida",
    "empty": "Diga olá com cuidado. No back-end compartilhado, as mensagens são sincronizadas com os dois telefones após uma correspondência mútua.",
    "placeholder": "Mensagem {name}…",
    "ariaMessage": "Mensagem",
    "send": "Enviar"
  },
  "billing": {
    "paywallCopy": "Após o teste gratuito, mantenha todos com quem você já combinou e continue conversando. Para ver novas pessoas, inscreva-se.",
    "signInToMatch": "Faça login para usar a correspondência.",
    "signInFirst": "Faça login primeiro.",
    "subscriberUntil": "Assinante · até {date}",
    "renewal": "renovação",
    "freeTrial": "Avaliação gratuita · {days} dias (termina em {date})",
    "soon": "breve",
    "trialEnded": "Teste encerrado · partidas e bate-papo permanecem abertos",
    "subscribe": "Inscrever-se · ${price}/mês",
    "subscribeEarly": "Inscreva-se antecipadamente · ${price}/mês",
    "activeNote": "Assinatura ativa – você pode ver novas pessoas novamente.",
    "playOnly": "A assinatura é apenas via Google Play Billing (instalação do app). Não há checkout web aqui.",
    "playOnlyShort": "Cobrança apenas pelo Google Play — sem pagamento web."
  },
  "auth": {
    "recoveryTitle": "Salve seu código de recuperação",
    "recoveryText": "Escreva isso agora. É mostrado uma vez. Se você perder sua senha, esse código será a única maneira de redefini-la no teste fechado.",
    "savedContinue": "Eu salvei – continue",
    "welcomeBack": "bem vindo de volta",
    "createAccount": "Crie sua conta",
    "intro": "Identificador e senha. Nenhum e-mail ou SMS é enviado. Seu ID permanece estável durante a integração, revisão e correspondência.",
    "tabLogin": "Conecte-se",
    "tabRegister": "Cadastre-se",
    "handle": "Lidar",
    "handlePlaceholder": "you@example.com ou um identificador curto",
    "passphrase": "Senha",
    "passphrasePlaceholder": "Pelo menos 8 caracteres",
    "submitLogin": "Conecte-se",
    "submitRegister": "Criar uma conta",
    "backWelcome": "Voltar para boas-vindas"
  },
  "options": {
    "origin": {
      "african": "africano",
      "european": "europeu",
      "asian": "Asiático",
      "latino": "Latino / Hispânico",
      "middleEastern": "Oriente Médio",
      "indigenous": "Indígena",
      "mixed": "Misturado",
      "other": "Outro",
      "dutch": "Holandês",
      "german": "Alemão",
      "any": "Aberto – sem preferência"
    },
    "interest": {
      "prayer": "Oração",
      "worship": "Adorar",
      "reading": "Leitura",
      "hiking": "Caminhada",
      "music": "Música",
      "cooking": "Culinária",
      "farming": "Agricultura / jardinagem",
      "sports": "Esportes",
      "missions": "Missões",
      "family": "Vida familiar",
      "crafts": "Artesanato",
      "outdoors": "Ao ar livre"
    }
  },
  "capture": {
    "yesNoDefaults": {
      "yes": "Sim",
      "no": "Não"
    },
    "id": {
      "titleEmpty": "ID do governo",
      "titleReady": "ID pronto",
      "hintEmpty": "Passaporte ou identidade nacional. Tire uma foto ao vivo ou escolha uma imagem/PDF. Todos os quatro cantos visíveis.",
      "hintReady": "{fileName} · {bytes}{saved}",
      "savedSuffix": "· salvo",
      "previewAlt": "Pré-visualização do ID governamental",
      "pdfAria": "Documento PDF selecionado",
      "takePhoto": "Tirar foto",
      "retake": "Retomar",
      "chooseFile": "Escolha o arquivo",
      "replaceFile": "Substituir arquivo",
      "remove": "Remover",
      "uploading": "Fazendo upload…",
      "cameraTitle": "Fotografe sua identidade",
      "signIn": "Faça login antes de enviar o ID.",
      "uploadFailed": "Falha no upload. Tente novamente.",
      "badFile": "Não foi possível usar este arquivo."
    },
    "video": {
      "titleEmpty": "Vídeo de confirmação",
      "titleLive": "Câmera ao vivo",
      "titleReady": "Vídeo pronto",
      "hintEmpty": "Diga seu primeiro nome e junte-se ao UN8 honestamente. 5–15 segundos.",
      "hintReady": "{fileName} · {bytes}{saved}",
      "rec": "REC {seconds}s",
      "record": "Registro",
      "cameraUpload": "Carregar câmera",
      "chooseFile": "Escolha o arquivo",
      "startRecording": "Comece a gravar",
      "cancel": "Cancelar",
      "stopSave": "Pare e salve",
      "recordAgain": "Grave novamente",
      "replaceFile": "Substituir arquivo",
      "remove": "Remover",
      "unsupported": "A gravação ao vivo não está disponível aqui. Use o upload da câmera ou escolha um arquivo.",
      "permissionDenied": "Permissão da câmera negada. Você ainda pode enviar um pequeno arquivo de vídeo.",
      "signIn": "Faça login antes de enviar o vídeo.",
      "uploadFailed": "Falha no upload. Tente novamente.",
      "saveFailed": "Não foi possível salvar a gravação.",
      "badVideo": "Não foi possível usar este vídeo."
    },
    "photos": {
      "count": "Fotos {count} / {max}",
      "minimumMet": "Mínimo atingido",
      "moreRequired": "{n} mais necessário",
      "listAria": "Fotos de verificação",
      "photoAlt": "Foto {n}",
      "removeAria": "Remover foto {n}",
      "camera": "Câmera",
      "takePhoto": "Tirar foto",
      "chooseFiles": "Escolha os arquivos",
      "uploading": "Fazendo upload…",
      "hint": "Tirar foto abre a câmera ao vivo. Escolher arquivos é apenas para escolhas de galeria. Fotos nítidas de rosto – sem filtros que escondam a identidade. Máx. {max}.",
      "cameraTitle": "Tire uma foto sua",
      "signIn": "Faça login antes de enviar fotos.",
      "someFailed": "Algumas fotos não foram carregadas. Tente novamente os que falharam.",
      "addFailed": "Não foi possível adicionar fotos."
    },
    "liveStill": {
      "titleDefault": "Câmera",
      "close": "Fechar",
      "capture": "Capturar",
      "cancel": "Cancelar",
      "hint": "Mantenha-se firme. A câmera ao vivo permanece aberta até você capturar.",
      "unavailable": "A câmera não está disponível neste navegador. Use Escolher arquivo.",
      "permissionDenied": "Permissão da câmera negada ou indisponível. Use Escolher arquivo.",
      "frameFailed": "Não foi possível capturar este quadro.",
      "saveFailed": "Não foi possível salvar a foto."
    },
    "uploadStatus": {
      "uploading": "carregando…",
      "failed": "falha no upload",
      "savedLocally": "salvo localmente",
      "uploaded": "carregado",
      "stored": "armazenado",
      "awaitingUpload": "Aguardando envio",
      "localFallbackNote": "O arquivo {error} é salvo neste dispositivo; tente novamente quando o ponto final do sinal estiver ativo."
    }
  },
  "language": {
    "label": "Idioma",
    "choose": "Escolha o idioma"
  },
  "shell": {
    "back": "Voltar",
    "goBackAria": "Volte"
  },
  "questionnaire": {
    "skipForNow": "Pular por agora",
    "skipConsequence": "Perfis respondidos aparecem primeiro.",
    "confirm": "Continuar",
    "progressLabel": "{current} de {total}",
    "fewSentences": "Algumas frases",
    "ancestryNote": "Isso é uma preferência que afeta apenas o ranking — nunca oculta ninguém."
  }
} as Messages;
